<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import BaseForm from './base-form';

export default {
    props: [
        'metroId',
        'regionId',
        'communityId',
    ],

    data: function() {
        return {
            ...BaseForm.data(),
            analytics: true,
            fields: {},
            persistents: {
                selected_metros: [],
                selected_regions: [],
                selected_communities: [],
            },
            brochure_url: '',
            // successMessage: 'temporary delete me' //used for success msg dev/styling
        }
    },

    mounted() {
        if (this.metroId) {
            this.persistents.selected_metros = [this.metroId];
        }
        if (this.regionId) {
            this.persistents.selected_regions = [this.regionId];
        }
        if (this.communityId) {
            this.persistents.selected_communities = [this.communityId];
        }
        this.boot();
    },

    computed: {
        ...BaseForm.computed
    },

    watch: {
        ...BaseForm.watchers,
    },

    methods: {
        ...BaseForm.methods,

        submit(event) {
            this.beforeSubmit().then((token) => {
                this.form.post(event.target.action, {
                        ...this.fields, ...this.persistents,
                        'g-recaptcha-response': token
                    })
                .then((result) => {
                    this.brochure_url = result.data.data.brochure_url;
                    this.success(result, event)
                })
                .catch(() => this.failure());
            });
        },

        loadPseudoConfirmation (response) {
            // create a hidden iframe element and set its source
            const iframe = document.createElement('iframe');

            iframe.style.display = 'none';
            iframe.src = '/forms/pseudo-confirmation-crosswind';
            iframe.referrerPolicy = 'same-origin';

            document.body.appendChild(iframe);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/forms/crosswind-lp-form.vue